/*
 *
 * File JS Principale
 *
 */

// IMPORT JQUERY
//--------------------------------------------------------------------//

import $ from "jquery";

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import "scss/app.scss";

//--------------------------------------------------------------------//

// Carichiamo i font in maniera asincrona
//--------------------------------------------------------------------//

var Webfont = require("webfontloader");

Webfont.load({
  google: {
    families: [
      "Albert+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
    ],
  },
  // typekit: { id: 'mgf5vqc' }
});

//--------------------------------------------------------------------//

// Libreria Lazysizes
//--------------------------------------------------------------------//
import "lazysizes";

//--------------------------------------------------------------------//

// Animations
//--------------------------------------------------------------------//
// imAnimationScaleOnscroll();

// imoprt common components
//--------------------------------------------------------------------//
import header from "components/header/header";
import menu from "components/menu/menu";
import button from "components/button/button";
import buttonOutline from "../components/buttonOutline/buttonOutline";
import footer from "components/footer/footer";
import accordion from "components/accordion/accordion";
import breadcrumb from "components/breadcrumb/breadcrumb";

import { entryTitleAnimation } from "./animations/entiry-title/entry-title";
entryTitleAnimation();

//--------------------------------------------------------------------//

// init common components
//--------------------------------------------------------------------//
header();
menu();
button();
accordion();

// Import Utilies
//--------------------------------------------------------------------//
import { initSvgImage } from "./utilities/img-svg";
import smoothScroll from "./utilities/smooth-scroll";
import { parallaxAnimation } from "./animations/parallax";

//--------------------------------------------------------------------//

// Init Utilies
//--------------------------------------------------------------------//

initSvgImage();
smoothScroll();
parallaxAnimation();
// depthMap();

//--------------------------------------------------------------------//
